function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState, useEffect, useRef } from 'react';
import { Col, Row, Breadcrumb, Dropdown } from 'react-bootstrap';
import { Link, useParams, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import TotalQualifyingRndExpenditure from '@rd-web-markets/shared/dist/dashboards/charts/TotalQualifyingRndExpenditure';
import TotalCumulativeBenefit from '@rd-web-markets/shared/dist/dashboards/charts/TotalCumulativeBenefit';
import TotalAndQECostsPerYear from '@rd-web-markets/shared/dist/dashboards/charts/TotalAndQECostsPerYear';
import ClaimStatePieChart from '@rd-web-markets/shared/dist/dashboards/charts/ClaimStatePieChart';
import CurrentYearQE from '@rd-web-markets/shared/dist/dashboards/charts/CurrentYearQE';
import TotaYearlylCostsPerCategory from '@rd-web-markets/shared/dist/dashboards/charts/TotaYearlylCostsPerCategory';
import dashboardService from '@rd-web-markets/shared/dist/services/dashboard.service';
import BreadcrumbsPortal from '@rd-web-markets/shared/dist/util/BreadcrumbsPortal';
import useRecentVisits from '@rd-web-markets/shared/dist/hooks/useRecentVisits';
import CurrentClaimYear from '@rd-web-markets/shared/dist/dashboards/charts/CurrentClaimYear';
import TopQEProject from '@rd-web-markets/shared/dist/dashboards/charts/TopQEProject';
import { DDMMYYYStringToDate } from '@rd-web-markets/shared/dist/util/date';
const getInitialSelectedYear = (search, claimGroup) => {
  const selectedYearQueryParam = new URLSearchParams(search).get('selected_year');
  if (selectedYearQueryParam) return selectedYearQueryParam;
  return claimGroup?.to_date ? DDMMYYYStringToDate(claimGroup.to_date).getFullYear() : null;
};
export default function Dashboard(_ref) {
  let {
    claimGroup,
    ...props
  } = _ref;
  const {
    search
  } = useLocation();
  const [selectedYear, setSelectedYear] = useState(() => getInitialSelectedYear(search, claimGroup));
  const user = useSelector(state => state.auth.user);
  const {
    company_id
  } = useParams();
  const {
    addRecentCompanyId
  } = useRecentVisits();
  useEffect(() => {
    addRecentCompanyId(company_id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company_id]);
  const dashboardData = dashboardService.useFetchDashboardDataForYear(company_id, selectedYear);
  const accountingPeriodPopoverContainerRef = useRef(null);
  useEffect(() => {
    setSelectedYear(getInitialSelectedYear(search, claimGroup));
  }, [search, claimGroup]);
  useEffect(() => {
    if (dashboardData && !selectedYear) {
      setSelectedYear(dashboardData.current_accounting_period);
    }
  }, [dashboardData, selectedYear]);
  const totalYearlyCostBarTitles = ['Employee', 'Consumables', 'Subcontractor', 'External Workers', 'Software', 'Cloud Computings', 'Data Licenses'];
  const totalYearlyCostDataFields = ['staffing_qe_costs', 'consumables_qe_costs', 'subcontractors_qe_costs', 'external_workers_qe_costs', 'software_qe_costs', 'cloud_computings_qe_costs', 'data_licences_qe_costs'];
  if (!dashboardData) return /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BreadcrumbsPortal, null, /*#__PURE__*/React.createElement(Breadcrumb, null, /*#__PURE__*/React.createElement(Breadcrumb.Item, {
    linkAs: Link,
    linkProps: {
      to: `/${user.account_type}`
    }
  }, "Home"), /*#__PURE__*/React.createElement(Breadcrumb.Item, {
    linkAs: Link,
    linkProps: {
      to: `/${user.account_type}/dashboards`
    }
  }, "Dashboards"), /*#__PURE__*/React.createElement(Breadcrumb.Item, {
    active: true
  }, dashboardData.company_name))), /*#__PURE__*/React.createElement("div", {
    className: "Dashboard"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "mb-2"
  }, /*#__PURE__*/React.createElement(Dropdown, null, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    as: Button,
    icon: "tune",
    variant: "primary",
    className: "ms-3 me-4"
  }, "Accounting Period"), /*#__PURE__*/React.createElement(Dropdown.Menu, {
    className: "dashboard-accountint-period-selector-container"
  }, /*#__PURE__*/React.createElement(CurrentClaimYear, {
    dashboardData: dashboardData,
    selectedYears: [selectedYear],
    selectYear: setSelectedYear
  })))), /*#__PURE__*/React.createElement(Row, _extends({}, props, {
    className: "mb-4"
  }), /*#__PURE__*/React.createElement(Col, {
    lg: 3
  }, /*#__PURE__*/React.createElement(CurrentYearQE, {
    dashboardData: dashboardData
  })), /*#__PURE__*/React.createElement(Col, {
    lg: 3
  }, /*#__PURE__*/React.createElement(ClaimStatePieChart, {
    className: "flex-grow-1",
    dashboardData: dashboardData
  })), /*#__PURE__*/React.createElement(Col, {
    lg: 6
  }, /*#__PURE__*/React.createElement(TotalAndQECostsPerYear, {
    dashboardData: dashboardData
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    lg: 6
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    lg: 12,
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(TotaYearlylCostsPerCategory, {
    dashboardData: dashboardData,
    barTitles: totalYearlyCostBarTitles,
    dataFields: totalYearlyCostDataFields
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    lg: 6
  }, /*#__PURE__*/React.createElement(TotalQualifyingRndExpenditure, {
    dashboardData: dashboardData
  })), /*#__PURE__*/React.createElement(Col, {
    lg: 6
  }, /*#__PURE__*/React.createElement(TotalCumulativeBenefit, {
    dashboardData: dashboardData
  })))), /*#__PURE__*/React.createElement(Col, {
    lg: 6
  }, /*#__PURE__*/React.createElement(TopQEProject, {
    dashboardData: dashboardData
  })))));
}